import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatKpiBarItem = createCustomElementWrapper('kat-kpi-bar-item', 'KatKpiBarItem', {
    'secondaryLabel': 'secondary-label',
    'showControlIcon': 'show-control-icon',
    'trendPolarity': 'trend-polarity',
}, {
    'onControlClick': 'controlClick',
}, [
    'error',
]);
